import { render, staticRenderFns } from "./Sinotico.vue?vue&type=template&id=0f2ac528&scoped=true"
import script from "./Sinotico.vue?vue&type=script&lang=js"
export * from "./Sinotico.vue?vue&type=script&lang=js"
import style0 from "./Sinotico.vue?vue&type=style&index=0&id=0f2ac528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ac528",
  null
  
)

export default component.exports